<template>
  <article
    class="cms-tile"
  >
    <component
      :is="getElement"
      class="cms-tile__link"
      :to="page?.PageUrl?.url"
    >
      <div
        class="cms-tile__visual"
      >
        <picture v-if="page?.Image?.url">
          <source
            :srcset="getProductImage(page.Image.url, 'f=rs:fit:500')"
            media="(min-width: 1024px)"
          >
          <source
            :srcset="getProductImage(page.Image.url, 'f=rs:fit:750')"
            media="(min-width: 768px)"
          >
          <source
            :srcset="getProductImage(page.Image.url, 'f=rs:fit:500')"
          >
          <img

            class="cms-tile__image"
            :src="getProductImage(page.Image.url, 'f=rs:fit:500')"
            :alt="page.Image.alternativeText || page.PageTitle"
            :width="page.Image.width"
            :height="page.Image.height"
            :loading="lazy ? 'lazy' : 'eager'"
            :fetchpriority="lazy ? 'low' : 'high'"
            :decoding="lazy ? 'async' : 'sync'"
          >
        </picture>
      </div>

      <div class="cms-tile__content">
        <div
          class="cms-tile__heading heading heading--1"
        >
          {{ page?.PageTitle }}
        </div>

        <p
          class="cms-tile__description"
        >
          <UiRichtext
            v-if="page?.Description"
            :html="page?.Description?.replaceAll('\n', '<br/>')"
          />
        </p>

        <span
          class="cms-tile__button button"
        >
          Lees meer
        </span>
      </div>
    </component>

    <!-- <pre>page: {{ page }}</pre> -->
  </article>
</template>

<script setup lang="ts">
import { AppLink } from '#components'

const props = defineProps<{
  page: any
  lazy: boolean
}>()

const getElement = computed(() => {
  if (props?.page?.PageUrl?.url) {
    return AppLink
  }

  return 'div'
})
</script>

<style src="~layers/app/components/Cms/Tile.css" />
